const settingComponents = {
    EV: [
        {
            languageOptions: [
                'primaryLanguage',
                'languages',
            ],
            upperPanel: [
                'surveyStatus',
                'noOfResponses',
            ],
            buttonPanel: ['buttonFields'],
        },
        'surveyName',
        'event',
        'topic',
        'audience',
        'eventOpenAndClose',
        'noVisitors',
        'noExhibitors',
        'countryEV',
        'cityEV',
        'cityOtherEV',
        'venueEV',
        'venueOtherEV',
        'primarySurvey',
        'test',
        'isParent',
        'surveyBranching',
        'useAiAssistant',
        'isSalesIntelligenceEnabled',
        'customMergeField',
        'defaultComparison',
        'surveyCloseDateTime',
    ],
    CEandPE: [
        {
            languageOptions: [
                'primaryLanguage',
                'languages',
            ],
            upperPanel: [
                'surveyStatus',
                'noOfResponses',
            ],
            buttonPanel: ['buttonFields'],
        },
        'surveyName',
        'event',
        'audience',
        'eventOpenAndClose',
        'eventFormat',
        'countryCE',
        'stateCE',
        'cityCE',
        'cityOtherCE',
        'venueOtherCE',
        'primarySurvey',
        'test',
        'isParent',
        'surveyBranching',
        'useAiAssistant',
        'isSalesIntelligenceEnabled',
        'customMergeField',
        'defaultComparison',
        'surveyCloseDateTime',
    ],
    EM: [
        {
            languageOptions: [
                'primaryLanguage',
                'languages',
            ],
            upperPanel: [
                'surveyStatus',
                'noOfResponses',
            ],
            buttonPanel: ['buttonFields'],
        },
        'surveyName',
        'event',
        'eventOpenAndClose',
        'countryCE',
        'stateCE',
        'cityCE',
        'cityOtherCE',
        'venueOtherCE',
        'customMergeField',
        'defaultComparison',
        'primarySurvey',
        'test',
        'useAiAssistant',
        'isSalesIntelligenceEnabled',
    ],
    VENU: [
        {
            languageOptions: [
                'primaryLanguage',
                'languages',
            ],
            upperPanel: [
                'surveyStatus',
                'noOfResponses',
            ],
            buttonPanel: ['buttonFields'],
        },
        'surveyName',
        'event',
        'topic',
        'audience',
        'eventOpenAndClose',
        'customMergeField',
        'defaultComparison',
        'primarySurvey',
        'test',
        'isParent',
        'surveyBranching',
        'useAiAssistant',
        'surveyCloseDateTime',
        'isSalesIntelligenceEnabled',
    ],
    template: [
        {
            languageOptions: [
                'primaryLanguage',
                'languages',
            ],
            upperPanel: ['publishButton'],
            buttonPanel: [],
        },
        'surveyName',
        'event',
        'topic',
        'templateLicenceType',
        'audience',
        'templateAccessAccordion',
        'templateCustomTags',
    ],
}
export default settingComponents
